import * as React from "react";

const HomeIcon = (
  props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M20.5091 9.72677L13.0085 2.90779C12.7329 2.65551 12.3729 2.5156 11.9994 2.51563C11.6258 2.51565 11.2658 2.65561 10.9904 2.90792L3.491 9.72673C3.33649 9.86743 3.21302 10.0388 3.12848 10.2299C3.04394 10.421 3.00018 10.6276 3 10.8366V19.5048C3 19.7018 3.0388 19.8969 3.1142 20.0789C3.18959 20.2609 3.3001 20.4262 3.4394 20.5655C3.57871 20.7048 3.74409 20.8153 3.9261 20.8907C4.10811 20.966 4.30319 21.0048 4.50019 21.0048L8.99955 21.0041C9.19844 21.0041 9.38919 20.9251 9.52982 20.7844C9.67045 20.6437 9.74946 20.453 9.74945 20.2541V14.2541H14.2495V20.2541C14.2495 20.453 14.3285 20.6437 14.4691 20.7844C14.6097 20.925 14.8005 21.0041 14.9994 21.0041L19.4998 21.0048H19.5C19.697 21.0048 19.892 20.966 20.074 20.8906C20.256 20.8152 20.4214 20.7047 20.5607 20.5654C20.6999 20.4262 20.8104 20.2608 20.8858 20.0788C20.9612 19.8968 21 19.7018 21 19.5048V10.8367C20.9998 10.6277 20.956 10.4211 20.8715 10.23C20.787 10.0389 20.6636 9.8675 20.5091 9.72677Z"
      fill={props.fill}
    />
  </svg>
);
export default HomeIcon;
